import { render, staticRenderFns } from "./MyAreaStoreButton.vue?vue&type=template&id=c84e9038&"
import script from "./MyAreaStoreButton.vue?vue&type=script&lang=ts&"
export * from "./MyAreaStoreButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports